import React, { Component } from "react";
import PageWrapper from "../../components/PageWrapper/PageWrapper";
import { Helmet } from "react-helmet";

class NotFound extends Component {

	constructor(props) {
		super(props);
		this.state = {
			uid : null
		}
	}
	
	render() {
		return (
			<PageWrapper context="page -error" full={true}>
			<Helmet title={`Page Not Found`} />
			<section className="header">
			<div className="container">
			<div className="content">
			<div className="rich-text">
			<div>
			<h1>Page Not Found</h1>
			<p>We couldn't find the page you were looking for.</p>
			</div>
			</div>
			</div>
			</div>
			</section>
			</PageWrapper>
		);
	}
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/pages/NotFound/NotFound.js